<section class="page">
  <header class="page__header">
    <div>
      <h1>Analysen</h1>
      <p>Gespeicherte Analyse-JSON aus Datenbank.</p>
    </div>
    <button type="button" class="secondary" (click)="refresh()" [disabled]="loading">Aktualisieren</button>
  </header>

  <p class="analysis-message" *ngIf="message">{{ message }}</p>

  <section class="analysis-filters">
    <label>
      Kuerzel
      <input type="text" [(ngModel)]="symbolFilter" placeholder="z. B. GCQ2026" />
    </label>
    <label>
      Analyse von
      <input type="date" [(ngModel)]="dateFrom" />
    </label>
    <label>
      Analyse bis
      <input type="date" [(ngModel)]="dateTo" />
    </label>
    <button type="button" class="secondary" (click)="clearFilters()">Filter leeren</button>
  </section>

  <section class="analysis-table-card">
    <table class="analysis-table">
      <thead>
        <tr>
          <th>Kuerzel</th>
          <th>Instrument</th>
          <th>Analysedatum</th>
          <th>Gespeichert</th>
          <th>Bias</th>
          <th>Varianten</th>
          <th>Uebernommen</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of filteredAnalyses(); trackBy: rowTrack">
          <td>
            <button type="button" class="analysis-link" (click)="openAnalysis(item)">
              {{ displaySymbol(item) }}
            </button>
          </td>
          <td>{{ item.instrument || '-' }}</td>
          <td>{{ item.analysisDateTime ? (item.analysisDateTime | date:'dd.MM.yyyy HH:mm') : (item.analysisDate || '-') }}</td>
          <td>{{ item.createdAt | date:'dd.MM.yyyy HH:mm' }}</td>
          <td>{{ item.biasDirection || '-' }} <span *ngIf="item.biasStrength">({{ item.biasStrength | number:'1.0-0' }}%)</span></td>
          <td>{{ item.variantCount || 0 }}</td>
          <td>{{ item.appliedTradeId ? 'Ja' : 'Nein' }}</td>
        </tr>
        <tr *ngIf="!filteredAnalyses().length && !loading">
          <td colspan="7" class="analysis-table__empty">Keine passenden Analysen gefunden.</td>
        </tr>
        <tr *ngIf="loading">
          <td colspan="7" class="analysis-table__empty">Analysen werden geladen...</td>
        </tr>
      </tbody>
    </table>
  </section>

  <app-analysis-dialog
    *ngIf="selectedAnalysis && selectedJson"
    [analysisData]="selectedJson"
    [showApply]="false"
    (close)="closeAnalysis()"
  ></app-analysis-dialog>
</section>
